import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import './styles.css';
import BasicControlGroup from '../../../../components/BasicControlGroup';
import LinkButton from '../../../../components/LinkButton';
import ReadMore from '../../../../components/ReadMore';
import {DateHelpers} from '../../../../helpers/date-helpers';
import ProfileRecommendations from '../ProfileRecommendations';

const ProfileItemEducation = props => {
  const { data, actions = {} } = props;

  const {
    UndergraduateSchoolID,
    Description,
    SchoolName,
    UndergraduateSchoolName,
    StartMonth,
    StartYear,
    EndMonth,
    EndYear,
    DegreeName,
    OfficeLocationName,
    Recommendations,
  } = data;

  const schoolName = SchoolName || UndergraduateSchoolName;

  const startDate = StartMonth
    ? `${DateHelpers.getMonthNameByIndex(StartMonth - 1)} ${StartYear}`
    : '';
  const endDate = EndMonth
    ? `${DateHelpers.getMonthNameByIndex(EndMonth - 1)} ${EndYear}`
    : '';
  const date = startDate + (endDate && startDate ? ' - ' : '') + endDate;

  const handleEditEducation = () => {
    if (actions.onEditEducation) {
      actions.onEditEducation(data);
    }
  };

  const handleDeleteEducation = () => {
    if (!UndergraduateSchoolID && actions.onDeleteEducation) {
      actions.onDeleteEducation(data);
    }
  };

  const handleAddRecommendation = () => {
    if (actions.onAddRecommendation) {
      actions.onAddRecommendation(data);
    }
  };

  return (
    <div className="profile-item-education">
      <div className="profile-item-education__header">
        <div className="profile-item-education__info">
          <h4 className="profile-item-education__school-name">{schoolName}</h4>
          {DegreeName && (
            <p className="profile-item-education__type">{DegreeName}</p>
          )}
          {OfficeLocationName && (
            <p className="profile-item-education__type">
              <span className="profile-item-education__field-of-study">
                {OfficeLocationName}
              </span>
            </p>
          )}
          <p className="profile-item-education__dates">
            <span className="profile-item-education__date">{date}</span>
          </p>
        </div>
        <MediaQuery query="(min-width: 768px)">
          <div className="profile-item-education__controls">
            <BasicControlGroup>
              {actions.onEditEducation && (
                <LinkButton text="Edit" controlFunc={handleEditEducation} />
              )}

              {!UndergraduateSchoolID &&
                props.actions &&
                props.actions.onDeleteEducation && (
                  <LinkButton
                    text="Delete"
                    controlFunc={handleDeleteEducation}
                  />
                )}

              {actions.onAddRecommendation && (
                <LinkButton
                  text="Add Recommendation"
                  controlFunc={handleAddRecommendation}
                />
              )}
            </BasicControlGroup>
          </div>
        </MediaQuery>
      </div>

      {Description && (
        <div className="profile-item-education__description">
          <ReadMore text={Description} readMoreCharacterLimit={180} />
        </div>
      )}

      {Recommendations && (
        <div className="profile-item-education__recommendations">
          <ProfileRecommendations list={Recommendations} />
        </div>
      )}

      <MediaQuery query="(max-width: 767px)">
        <div className="profile-item-education__controls">
          <BasicControlGroup>
            {actions.onEditEducation && (
              <LinkButton text="Edit" controlFunc={handleEditEducation} />
            )}
            {!UndergraduateSchoolID &&
              props.actions &&
              props.actions.onDeleteEducation && (
                <LinkButton text="Delete" controlFunc={handleDeleteEducation} />
              )}
            {actions.onAddRecommendation && (
              <LinkButton
                text="Add Recommendation"
                controlFunc={handleAddRecommendation}
              />
            )}
          </BasicControlGroup>
        </div>
      </MediaQuery>
    </div>
  );
};

ProfileItemEducation.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object,
};

export default ProfileItemEducation;
